import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import AboutImg from "../../assets/images/about-img.jpg";
import MissionImg from "../../assets/images/our-mission.jpg";
import VisionImg from "../../assets/images/our-vision.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export const AboutSec = () => {
  return (
    <>
      <div className="common-banner">
        <div className="container">
          <div className="banner-content">
            <h2>About Us</h2>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  About Us
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="about-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 about-left">
              <div className="about-img w-75 mx-auto">
                <img src={AboutImg} alt="about image" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title">
                <h4>Best Mobile Application Development Agency</h4>
                <h2>About the CodeInfoWay</h2>
                <p>
                  Our mission is to help you achieve your goals by consulting
                  on, creating and maintaining custom software and apps that
                  makes a real and positive difference in your business.
                </p>
                <p>
                  We want to offer our clients only those features and options
                  we know will be valuable to your business. Our goal is not to
                  max out the budget, rather to learn as much as we can about
                  our clients and their businesses, then propose the most
                  appropriate service.What we do is based on common sense, not
                  ethics. You will pay for what you want and will get it with no
                  further questions, which is why we will be straightforward
                  with you and find win-win solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="our-mission">
        <div className="title bg-dark py-5 px-5 mb-3 mb-lg-5 position-relative">
          <h4 className="text-center">Driving Innovation, Empowering Growth</h4>
          <h2 className="text-white text-center">Our Commitment to Success</h2>
          <div className="down-arrow">
            <FontAwesomeIcon icon={faPlay} />
          </div>
        </div>
        <div className="container">
          <div className="row align-items-center mb-3 mb-lg-5 pt-5">
            <div className="col-lg-6">
              <img
                src={MissionImg}
                alt="Mission Image"
                className="w-100 mb-3 mb-lg-0"
              />
            </div>
            <div className="col-lg-6">
              <div className="title">
                <h3 className="fw-bold">Our Mission</h3>
                <p>
                  Our mission is to empower businesses by creating innovative
                  and impactful software solutions that simplify processes,
                  enhance productivity, and deliver exceptional value. We are
                  committed to understanding our clients' unique challenges and
                  providing tailored technology solutions that help them achieve
                  their goals with confidence and efficiency.
                </p>
                <p>
                  Our mission is to empower businesses by creating innovative
                  and impactful software solutions that simplify processes,
                  enhance productivity, and deliver exceptional value. We are
                  committed to understanding our clients' unique challenges and
                  providing tailored technology solutions that help them achieve
                  their goals with confidence and efficiency.
                </p>
              </div>
            </div>
          </div>
          <div className="row align-items-center mb-3 mb-lg-5 py-0 py-lg-5 flex-column-reverse flex-lg-row">
            <div className="col-lg-6">
              <div className="title">
                <h3 className="fw-bold">Our Vision</h3>
                <p>
                  Our vision is to become a globally recognized leader in
                  software development, known for our expertise, reliability,
                  and ability to transform ideas into cutting-edge solutions. We
                  aim to foster long-term partnerships, drive digital
                  transformation, and make a positive impact on businesses and
                  communities worldwide.
                </p>
                <p>
                  Our vision is to become a globally recognized leader in
                  software development, known for our expertise, reliability,
                  and ability to transform ideas into cutting-edge solutions. We
                  aim to foster long-term partnerships, drive digital
                  transformation, and make a positive impact on businesses and
                  communities worldwide.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                src={VisionImg}
                alt="Vision Image"
                className="w-100  mb-3 mb-lg-0"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="achivement-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="title">
                <h4>Celebrating Milestones and Recognizing Excellence</h4>
                <h2>Our Achivements</h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title">
                <p>
                  We take pride in delivering impactful solutions and building long-term
                  relationships with our clients. Our journey is defined by innovation,
                  dedication, and a commitment to excellence. From successful project
                  deliveries to a growing team of skilled professionals, every milestone
                  reflects our passion for creating high-quality digital experiences.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-3 col-md-6">
              <div className="box box-dark">
                <h3>10+</h3>
                <h5>Our Team</h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="box box-dark">
                <h3>65+</h3>
                <h5>completed Project</h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="box box-dark">
                <h3>50+</h3>
                <h5>Mobile Apps</h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="box box-dark">
                <h3>15+</h3>
                <h5>Web Apps</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cta-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2>Would you like to execute any project?</h2>
              <Link to="/contact-us" className="btn btn-primary mt-3">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
